import { DOCUMENT } from "@angular/common";
import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output,
} from "@angular/core";
import * as _ from "lodash";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";

@Component({
    selector: "[reject-timecard-popover]",
    templateUrl: "./reject-popover.component.html",
    standalone: false
})
export class RejectPopoverComponent implements OnInit {
    constructor(
        private _eventBusService: EventBusService,
        @Inject(DOCUMENT) private _document: Document
    ) {}

    rejectcomment: any;

    @Input()
    listItem: any;

    @Input()
    previousDepts: any = [];

    @Input()
    user: any;

    @Input()
    rejectingDept: any;

    @Output()
    onClosePopover: EventEmitter<any> = new EventEmitter();

    onTimecardReject(listId, key) {
        this.listItem.rejectComment = this.rejectcomment;
        if (this.validateReject(this.listItem)) {
            const data = {
                listItem: this.listItem,
                key: this.rejectingDept || key,
            };
            this._eventBusService.emit(
                new EmitEvent(
                    "rejectPopover:onTimecardReject",
                    "onTimecardRejectWithReason",
                    data
                )
            );

            if (data.listItem.DontCloseRejectPopover) {
                this.closePopup();
            }
        }
    }

    onDeptSelect(selectedDept) {
        this.listItem.rejectedDept = selectedDept;
        _.set(this.listItem, "isRejectionDepartmentChanged", true);
        this._eventBusService.emit(
            new EmitEvent(
                "rejectPopover:onDeptSelect",
                "onListItemChanged",
                this.listItem
            )
        );
        this.validateReject(this.listItem);
    }

    onrejectCommentChange(comments) {
        const rejectinfo = {
            rejectId: 0,
            isRejected: true,
            rejectcomments: comments,
            rejectedOn: new Date(),
            rejectedBy: this.user.id,
            tpmDepartment: {
                id: this.listItem.rejectedDept,
            },
        };
        this.listItem.rejectComment = comments;
        const rejectedItem = _.find(this.listItem.rejectStatus, {
            rejectId: 0,
        });
        if (_.isEmpty(this.listItem.rejectStatus)) {
            this.listItem.rejectStatus = [rejectinfo];
        } else {
            if (_.isUndefined(rejectedItem)) {
                this.listItem.rejectStatus.push(rejectinfo);
            } else {
                rejectedItem.rejectcomments = comments;
            }
        }
        this.validateReject(this.listItem);
    }

    oncloseReject() {
        this.listItem.rejectedDept =
            this.listItem.dept.length === 1
                ? this.listItem.dept[0].department.id
                : null;
        if (_.isEmpty(this.listItem.rejectStatus)) {
            this.listItem.rejectStatus = null;
        } else {
            const delrejectinfo = _.find(this.listItem.rejectStatus, {
                rejectId: 0,
            });
            this.listItem.rejectStatus.pop(delrejectinfo);
            if (this.listItem.rejectStatus.length === 0) {
                this.listItem.rejectStatus = null;
            }
        }
        this.closePopup();
    }

    closePopup() {
        this.onClosePopover.emit("");
    }

    validateReject(item) {
        const rejectedItem = _.find(item.rejectStatus, { rejectId: 0 });
        if (
            !_.isUndefined(rejectedItem) &&
            rejectedItem.rejectcomments !== null &&
            rejectedItem.rejectcomments !== "" &&
            item.rejectedDept !== null
        ) {
            item.businessValidation.canReject = false;

            this.highlightField(false, "rejectcomment", item.id);
            this.highlightField(false, "dept", item.id);

            if (!_.isUndefined(rejectedItem.tpmDepartment)) {
                rejectedItem.tpmDepartment.id = item.rejectedDept;
            }
        } else {
            item.businessValidation.canReject = true;

            this.highlightField(true, "rejectcomment", item.id);
            this.highlightField(true, "dept", item.id);
        }
        return !item.businessValidation.canReject;
    }

    highlightField(setHighlight, key, id) {
        setTimeout(() => {
            const validation_selector = "#" + key + "-validationmsg-" + id;
            // let field_selector = "[name='" + key + "-" + id + "']";
            const field_selector = "#" + key + "-" + id;

            const $span = this._document.querySelector(validation_selector);
            let field = this._document.querySelector(field_selector);
            if (field?.tagName == "NBC-SELECT") field = field.parentElement;

            if (setHighlight) {
                if ($span) 
                    {
                        $span.classList.remove("d-none");
                        $span.classList.remove("hide");
                    }
                if (field) field.classList.add("required-field");
            } else {
                if ($span) 
                    {
                        $span.classList.add("d-none");
                        $span.classList.remove("hide");
                    }
                if (field) field.classList.remove("required-field");
            }
        }, 100);
    }

    ngOnInit() {
        if (this.listItem) this.listItem.businessValidation.canReject = true;
    }
}
